import { useState } from 'react';

import { gql, useQuery } from '@apollo/client';

export const GET_PROCESSES_WITH_PAGINATION = gql`
  query getProcessesWithPagination($queryOptions: QueryOptionsInput!) {
    getProcessesWithPagination(queryOptions: $queryOptions) {
      collection {
        _id
        title
        createdBy
      }
      totalCount
    }
  }
`;

export const useGetProcessesWithPagination = () => {
  const [currentPage, setPage] = useState(1);
  const [currentNameSort, setNameSort] = useState<{ field: string; sortBy: number }[]>([]);
  const pageSize = 12;
  const { data, loading } = useQuery(GET_PROCESSES_WITH_PAGINATION, {
    variables: {
      queryOptions: {
        limit: pageSize,
        skip: pageSize * currentPage - pageSize,
        sort: currentNameSort,
      },
    },
    fetchPolicy: 'network-only',
  });

  const { collection = [], totalCount = 0 } = data?.getProcessesWithPagination || {};

  return {
    loading,
    processes: collection,
    onTableChange: (a: any, b: any, { order }: any) => {
      const sortArray = [];

      if (order) {
        const sortBy = order === 'ascend' ? 1 : -1;

        sortArray.push({ field: 'title', sortBy });
      }

      setNameSort(sortArray);
    },
    paginationConfig: {
      pageSize,
      total: totalCount,
      current: currentPage,
      onChange: (page: number) => setPage(page),
    },
  };
};
